import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GlobalModule } from '../global/global.module';

import { RESIDENCE_SERVICE_PROVIDER } from './service/residence.service';
import { ReviewResidenceDialogComponent } from './dialogs/review-residence-dialog/review-residence-dialog.component';
import { VerifyAddressDialogComponent } from './dialogs/verify-address-dialog/verify-address-dialog.component';
import { RenameResidenceDialogComponent } from './dialogs/rename-residence-dialog/rename-residence-dialog.component';
import { ChangeSubTypeDialogComponent } from './dialogs/change-subtype-dialog/change-subtype-dialog.component';

@NgModule({
    declarations: [ReviewResidenceDialogComponent, VerifyAddressDialogComponent, RenameResidenceDialogComponent, ChangeSubTypeDialogComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MatDialogModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, GlobalModule],
    providers: [RESIDENCE_SERVICE_PROVIDER],
})
export class ResidenceModule {}
